module.exports = __webpack_public_path__ + "static/media/md-mail-open.0da036c2.svg";